import qs from "qs";
import { isLinjieApp, isInWechatWebview } from "@/utils/env-related";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import jb from "@frontend/effuse";

export const prepareJump = ({
  atrr,
  targetPath,
  params,
}: {
  atrr: string;
  targetPath: string;
  params: any;
}) => {
  (window as any).MobLink({
    el: atrr,
    path: targetPath,
    default: true,
    loadDataType: "1", //配置是否加loading，配置代表加入loading，不配置则没有loading动画
    params,
  });
};

// https://a.app.qq.com/o/simple.jsp?pkgname=tech.echoing.congress&android_scheme=congress%3A%2F%2Ftoken-detail%3FtokenId%3D548794316743519928&ios_scheme=congress%3A%2F%2Ftoken-detail%3FtokenId%3D548794316743519928

// 微信里 scheme / 应用宝自动跳转都会被拦截，无法静默唤起 App，
// 零配置下唯一可行的做法是引导用户去系统浏览器打开（浏览器里唤起/下载才通）。
const WECHAT_GUIDE_IMG =
  "https://cdn.qiandaoapp.com/admins/137127a2f28c2accdd5285fbc0cc398e.png";

const showWechatBrowserGuide = () => {
  const id = "wechat-browser-guide";
  if (document.getElementById(id)) return; // 防重复
  const mask = document.createElement("div");
  mask.id = id;
  mask.style.cssText =
    "position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;background:rgba(0,0,0,0.75);overflow:auto;";
  const img = document.createElement("img");
  img.src = WECHAT_GUIDE_IMG;
  img.style.cssText = "width:100%;height:auto;display:block;";
  mask.appendChild(img);
  mask.addEventListener("click", () => mask.remove()); // 点击任意处关闭
  document.body.appendChild(mask);
};

export const invokeAppByYYB = ({
  targetPath,
  params,
}: {
  targetPath: string;
  params: any;
}) => {
  const pkgName = "tech.echoing.congress";
  const tempParams = qs.stringify(params);
  const originTargetUrl = `congress://${targetPath}?${tempParams}`;
  const encodedTargetUrl = encodeURIComponent(originTargetUrl);

  if (isLinjieApp()) {
    jb.navigateTo({ url: originTargetUrl });
    return;
  }

  // 微信内无法唤起，引导去浏览器打开
  if (isInWechatWebview()) {
    showWechatBrowserGuide();
    return;
  }

  const resultUrl = `https://a.app.qq.com/o/simple.jsp?pkgname=${pkgName}&android_scheme=${encodedTargetUrl}&ios_scheme=${encodedTargetUrl}`;
  console.log("resultUrl", resultUrl);

  window.location.href = resultUrl;
};

// mobLinkAttr
// prepareJump
